<div class="container">
  <h1>
    @if (projectInfo?.ProjectName) {
      <span>
        {{ projectInfo?.ProjectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>

  <p role="alert" class="step">Thank you! You have successfully registered to take the survey!</p>

  @if (showProgressBar) {
    <div class="progress-bar-timer" aria-live="polite">
      <p>You will be automatically redirected in 5 seconds...</p>
      <mat-progress-bar id="progressBar" mode="determinate" [value]="progressValue"></mat-progress-bar>
      <button class="blue-button cancel-button" (click)="cancelRedirect()">Stay on this page</button>
    </div>
  }

  @if (!showProgressBar) {
    <div class="manual-redirect" aria-live="polite">
      <p>Click below to continue when you're ready.</p>
      <button class="blue-button proceed-button" (click)="redirectToSurvey()">Proceed</button>
    </div>
  }
</div>
